module.exports = __webpack_public_path__ + "media/images/application2/Button--icon-upload-691ed09d921dd5bfdda27fd4febf85e7.svg";